import React from 'react';

import DialogContentText from '@material-ui/core/DialogContentText';
import MuiTab from '@material-ui/core/Tab';

import { EMAIL_DIALOG_TYPES } from '../engine/EmailDialogEngine';
import _GeneralDialog from '../../internal-components/GeneralDialog';
import ComposeEmail from '../engine/ComposeEmailEngine';
import EditTemplate from '../engine/EditEmailTemplateEngine';
import Preview from '../engine/PreviewEmailEngine';
import _Tabs from '../engine/TabsEngine';
import _Animation from '../Animation';

import styled from 'styled-components/macro';
import TaskFrequencyEngine from '../engine/TaskFrequencyEngine';

export const Tabs = styled(_Tabs)`
  && {
    margin-bottom: 1.2em;
  }
`;

export const AnimationContainer = styled.div`
  display: flex;
  overflow: hidden;
`;

export const Animation = styled(_Animation)`
  && {
    width: 100%;
  }
`;

export const Tab = styled(MuiTab)`
  && {
    ${({ display }) => !display && 'display: none;'}
  }
`;

const GeneralDialog = styled(_GeneralDialog)`
  [class*='MuiDialogContent-root'] {
    min-height: 575px;
  }
`;

const EmailDialogView = props => {
  const { COMPOSE_BLANK, COMPOSE, TEMPLATE } = EMAIL_DIALOG_TYPES;
  const {
    COMPOSE: COMPOSE_TAB,
    EDIT_TEMPLATE: EDIT_TEMPLATE_TAB,
    PREVIEW: PREVIEW_TAB,
    FREQUENCY: FREQUENCY_TAB
  } = props.TAB_VALUES;

  return (
    <GeneralDialog
      scroll="body"
      open={props.open}
      handleClose={props.handleClose}
      handleConfirm={props.dialogHandleConfirm}
      fullWidth
      disableBackdropClick
      noX
      title={props.title}
      isLoading={props.isLoading}
      buttons={props.buttons}
      confirmConfirmation={
        props.data.subject && props.data.subject.length === 0
      }
      onConfirmConfirmationMessage="email_dialog.warning"
      {...props}
    >
      {props.description.length > 0 && (
        <DialogContentText>{props.description}</DialogContentText>
      )}

      <Tabs
        value={props.activeTab}
        onChange={(event, newValue) => props.setActiveTab(newValue)}
      >
        <Tab label="Compose" display={props.type !== TEMPLATE} />
        <Tab label="Edit Template" display={props.type === TEMPLATE} />
        <Tab label="Preview" display />
        <Tab label="Frequency" display={props.showFrequencyTab} />
      </Tabs>
      <AnimationContainer>
        <Animation
          in={props.activeTab === COMPOSE_TAB}
          mountOnEnter // very important
          unmountOnExit // very important
          type="slide"
          direction="right"
          timeout={{
            enter: 250,
            exit: 100
          }}
        >
          <ComposeEmail data={props.data} {...props.composeEmailProps} />
        </Animation>
        <Animation
          in={props.activeTab === EDIT_TEMPLATE_TAB}
          mountOnEnter // very important
          unmountOnExit // very important
          type="slide"
          direction="right"
          timeout={{
            enter: 250,
            exit: 100
          }}
        >
          <EditTemplate
            data={props.data}
            templateId={props.templateId}
            {...props.editTemplateProps}
          />
        </Animation>
        <Animation
          in={props.activeTab === PREVIEW_TAB}
          mountOnEnter // very important
          unmountOnExit // very important
          type="slide"
          direction="left"
          timeout={{
            enter: 250,
            exit: 100
          }}
        >
          <Preview
            subject={props.previewSubject}
            body={props.previewBody}
            {...props.previewEmailProps}
          />
        </Animation>
        <Animation
          in={props.activeTab === FREQUENCY_TAB}
          mountOnEnter // very important
          unmountOnExit // very important
          type="slide"
          direction="left"
          timeout={{
            enter: 250,
            exit: 100
          }}
        >
          <TaskFrequencyEngine type={props.showFrequencyTab} />
        </Animation>
      </AnimationContainer>
    </GeneralDialog>
  );
};

export default EmailDialogView;
